import { Link } from "gatsby"
import React, { Component } from "react"
import { COLORS } from "../../utils/Colors"

export default function Tab({ name, link }) {
  return name === "Blog" ? (
    <a
      style={{
        ...styles.tabs,
        color: COLORS.TAB_FONT_COLOR,
      }}
      href="http://www.riktamtech.com/blog"
    >
      {name}
    </a>
  ) : (
      <Link
        style={{
          ...styles.tabs,
          color: COLORS.TAB_FONT_COLOR,
        }}
        activeStyle={{ color: COLORS.THEME_COLOR }}
        activeClassName="active-link"
        to={link}
      >
        {name}
        <div className="active-dot d-flex justify-content-center">
          <div style={styles.dot} />
        </div>
      </Link >
    )
}

const styles = {
  tabs: {
    marginLeft: 20,
    marginRight: 20,
    display: "inline-block",
    cursor: "pointer",
    textDecoration: "none",
    fontFamily: "SFProMed",
    fontSize: 12,
  },
  dot: {
    width: 10,
    height: 10,
    borderRadius: 20,
    backgroundColor: COLORS.THEME_COLOR,
    marginTop: 20,
  },
}
